import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Button } from '@ui';
import Loader, { LoaderSizes } from '@components/v2/Loader';
import { translate } from '@utils/i18n';
import { NAMESPACE } from '../constants';
export default function ConfirmSubmissionModal({ isOpen, onClose, onConfirm, isSubmitting, formValues, prepopulateData }) {
    var _a, _b;
    if (!isOpen)
        return null;
    return (React.createElement(Dialog, { title: translate('form.confirm_submission.title', { namespace: NAMESPACE }), onClose: onClose, width: "700px", className: "qmb-v2-modal confirm-submission-modal" },
        React.createElement("div", { className: "qmb-v2-modal__content" },
            React.createElement("p", null, translate('form.confirm_submission.message', { namespace: NAMESPACE })),
            React.createElement("div", { className: "confirmation-fields" },
                React.createElement("div", { className: "confirmation-field" },
                    React.createElement("strong", null,
                        translate('form.fields.kit_number', { namespace: NAMESPACE }),
                        ":"),
                    React.createElement("div", null, formValues.kit_number)),
                React.createElement("div", { className: "confirmation-field" },
                    React.createElement("strong", null,
                        translate('form.fields.job_name', { namespace: NAMESPACE }),
                        ":"),
                    React.createElement("div", null, formValues.job_name || '-')),
                React.createElement("div", { className: "confirmation-field" },
                    React.createElement("strong", null,
                        translate('form.fields.building_address', { namespace: NAMESPACE }),
                        ":"),
                    React.createElement("div", null, (prepopulateData === null || prepopulateData === void 0 ? void 0 : prepopulateData.building.address) || '-')),
                React.createElement("div", { className: "confirmation-field" },
                    React.createElement("strong", null,
                        translate('form.fields.total_samples', { namespace: NAMESPACE }),
                        ":"),
                    React.createElement("div", null, formValues.total_samples)),
                React.createElement("div", { className: "confirmation-field" },
                    React.createElement("strong", null,
                        translate('form.confirm_submission.rush', { namespace: NAMESPACE }),
                        ":"),
                    React.createElement("div", null,
                        React.createElement("span", null, formValues.priority === 'rush'
                            ? translate('yes', { namespace: 'generic' })
                            : translate('no', { namespace: 'generic' })))),
                React.createElement("div", { className: "confirmation-field" },
                    React.createElement("strong", null,
                        translate('form.sections.send_results_to', { namespace: NAMESPACE }),
                        ":"),
                    React.createElement("div", null,
                        ((_a = formValues.send_results_to) === null || _a === void 0 ? void 0 : _a.name) || '-',
                        ((_b = formValues.send_results_to) === null || _b === void 0 ? void 0 : _b.email) && React.createElement(React.Fragment, null,
                            " (",
                            formValues.send_results_to.email,
                            ")"))))),
        React.createElement("div", { className: "qmb-v2-modal__footer" },
            React.createElement(Button, { onClick: onClose, disabled: isSubmitting }, translate('cancel', { namespace: 'generic' })),
            React.createElement(Button, { variant: "primary", onClick: onConfirm, disabled: isSubmitting }, isSubmitting ? (React.createElement(React.Fragment, null,
                React.createElement(Loader, { size: LoaderSizes.small }),
                translate('loading', { namespace: 'generic' }))) : (translate('confirm', { namespace: 'generic' }))))));
}
